import isNil from 'lodash/isNil';
import { Candidate } from '../firebase/firestore/documents/candidate';
import { isCandidateFromFollowedOrWatchedPosition } from './CandidateService';

export const filteredCandidatesByRestriction = (
  candidates: Candidate[] | undefined,
  isUserRestrictedInPositions: boolean | undefined,
  userId: string | undefined,
): Candidate[] | undefined =>
  candidates?.filter((value) => {
    if (isUserRestrictedInPositions && userId) {
      return isCandidateFromFollowedOrWatchedPosition(value, userId);
    }
    return true;
  });

export const isAdministrationAccount = (appOwnersId: string[] | undefined, appUserId: string | undefined): boolean =>
  !isNil(appOwnersId) && !isNil(appUserId) && appOwnersId?.includes(appUserId);

export const isSuperAdministrationAccount = (superOwners: string[] | undefined, appUserId: string | undefined): boolean => {
  if (!superOwners || !appUserId) {
    return false;
  }
  return superOwners?.includes(appUserId);
};

type IsUserRestrictedInPositionsParams = {
  appOwnersId?: string[] | undefined;
  appUserId?: string | undefined;
  superOwners: string[];
  isUserRestricted?: boolean;
};

export const checkIfUserRestrictedInPositions = ({
  appOwnersId,
  appUserId,
  superOwners,
  isUserRestricted,
}: IsUserRestrictedInPositionsParams): boolean =>
  !isAdministrationAccount(appOwnersId, appUserId) &&
  !isSuperAdministrationAccount(superOwners, appUserId) &&
  Boolean(isUserRestricted);
